import React, { FC, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { PostPetition } from "../../interface/api";
import { petition_validate } from "../../validate/post";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPostPetition } from "../../api/post";
import { useNotificationService } from "../../hooks/notification";
import { HandsFistIcon, LoadingSpinner } from "../ui-elements/svg-icons";
import ImageGrid from "../image-grid";
import TypographyContent from "../ui-elements/typography-content";
import { PostPetitionModal, SendPetitionModal } from "./modal-post";


const PetitionPreview: FC<{
  petition_data: PostPetition;
  set_page_default: () => void;
  close_modal: () => void;
  setPetition_data: React.Dispatch<React.SetStateAction<PostPetition>>;
}> = ({ petition_data, setPetition_data, close_modal, set_page_default }) => {
  const { showNotification } = useNotificationService();
  const queryClient = useQueryClient()
  const [pre_submit, setPre_submit] = useState(false);
  const [submit_modal, setSubmit_modal] = useState(false);

  const handle_pre_modal = () => {
    setPre_submit(!pre_submit);
  };
  const handle_submit_modal = () => {
    setSubmit_modal(!submit_modal);
  };

  const submit_petition = () => {
    const { bool, text } = petition_validate(petition_data);
    if (!bool) {
      showNotification(text, "warning");
    } else {
      handle_pre_modal();
    }
  };
  const handle_submit = async () => {
    setPre_submit(false);
    const data = {
      ...petition_data,
      media: petition_data?.media?.map(
        (image: { data_url: string; file: File }) => image?.file
      ),
    };
    
    mutation.mutate(data);
  };

  const mutation = useMutation({
    mutationFn: (fields: PostPetition) => apiPostPetition(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("details" in data) {
          showNotification(data.details, "error");
          return;
        }
        return;
      }
      if (data.status === 201) {
        showNotification(
          "Your Petition has been submitted successfully!",
          "success"
        );
           // **Clear and refetch dashboard data**
    queryClient.removeQueries({ queryKey: ["dashboard"] });
    queryClient.refetchQueries({ queryKey: ["dashboard"] });
        setPetition_data({
          target_signatures: "500",
          title: "",
          media: [],
          context: "",
          target_representative_ids: [""],
          post_type: "petition",
        });

        handle_submit_modal();
      }
    },
    onError: (error) => {},
  });

  return (
    <Box>
      <PostPetitionModal
        open={pre_submit}
        modal_handler={handle_pre_modal}
        onSubmit={handle_submit}
      />
      <SendPetitionModal
        open={submit_modal}
        modal_handler={handle_submit_modal}
        close_modal={close_modal}
        set_page_default={set_page_default}
      />
      <Box
        sx={{
          width: "100%",
          height: "4px",
          background: "url(/assets/icons/posts/line-05.png)",
        }}
      />
      <Box sx={{ m: 3 }}>
        <Stack sx={{ my: 2 }}>
          <Typography sx={{}}>{petition_data.title}</Typography>
        </Stack>
        <Stack sx={{ m: 2 }}>
          <ImageGrid
            images={petition_data.media?.map(
              (img_link: { data_url: string; file: File }) => img_link?.data_url
            )}
          />
        </Stack>
        <Box
          sx={{
            marginVertical: 14,
          }}
        ></Box>
        <Box>
          <TypographyContent content={petition_data.context} />
        </Box>
      </Box>
      <Stack sx={{ my: 3 }} direction={"row"} justifyContent={"center"}>
        {!mutation.isPending ? (
          <Button
            variant="contained"
            color="primary"
            onClick={submit_petition}
            startIcon={<HandsFistIcon />}
            sx={{
              mt: 2,
              borderRadius: "40px",
              width: "80%",
              mx: "auto",
            }}
          >
            Submit petition
          </Button>
        ) : (
          <LoadingSpinner />
        )}
      </Stack>
    </Box>
  );
};

export default PetitionPreview;
